import { SkeletonRegistryCategory } from '../../../registry/skeleton/SkeletonRegistryCategory';
export class RareSkeletonsQuestion extends SkeletonRegistryCategory {
    label = 'Question';
    constructor(parent) {
        super(parent);
        super.init();
    }
}
